"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRawFacetToRangeFacet = exports.mapRawFacetToCheckboxFacet = void 0;
var isUndefined_1 = require("./isUndefined");
function isArgs(args) {
    return !isUndefined_1.isUndefined(args.parentId);
}
function mapRawFacetToCheckboxFacet(rawFacetOrArgsObject, parentId, name, searchBoxPlaceholderText) {
    if (isArgs(rawFacetOrArgsObject)) {
        var name_1 = rawFacetOrArgsObject.name, parentId_1 = rawFacetOrArgsObject.parentId, rawFacet_1 = rawFacetOrArgsObject.rawFacet, searchBoxPlaceholderText_1 = rawFacetOrArgsObject.searchBoxPlaceholderText;
        return {
            id: parentId_1,
            name: name_1,
            type: 'checkbox',
            searchBoxPlaceholderText: searchBoxPlaceholderText_1,
            filters: Object.keys(rawFacet_1).map(function (key) { return ({
                checked: false,
                count: Number(rawFacet_1[key]),
                parentId: parentId_1,
                label: key,
                id: key,
            }); }),
        };
    }
    // We know that it's overload 2 where all of the params are provided separately,
    // and thus we can safely assert that they are not undefined.
    var rawFacet = rawFacetOrArgsObject;
    return {
        id: parentId,
        name: name,
        type: 'checkbox',
        searchBoxPlaceholderText: searchBoxPlaceholderText,
        filters: Object.keys(rawFacet).map(function (key) { return ({
            checked: false,
            count: Number(rawFacet[key]),
            parentId: parentId,
            label: key,
            id: key,
        }); }),
    };
}
exports.mapRawFacetToCheckboxFacet = mapRawFacetToCheckboxFacet;
function mapRawFacetToRangeFacet(parentId, name, id) {
    return {
        id: parentId,
        name: name,
        type: 'range',
        filters: {
            id: id,
            parentId: parentId,
            min: null,
            max: null,
            label: name,
        },
    };
}
exports.mapRawFacetToRangeFacet = mapRawFacetToRangeFacet;
